// Libs
import React from 'react';
import { Link } from 'react-router-dom';

export default class NoRoute extends React.Component {
  render() {
    document.title = '404 Sift Happens';
    return (
      <div style={{ textAlign: 'center', width: '100%' }}>
        <h1 style={{ fontSize: 100, fontWeight: 500 }}> 404 </h1>
        <h2> Sift Happens! </h2>
        <p>We can help you find a lot of things – this page is not one of them.</p>
        <p>
          Try going back or head on <Link to="/admin">home</Link>.
        </p>
      </div>
    );
  }
}
